import { t } from '@hefe/i18n';
import { BasketballSwitchRequestSwitchType, SelectOption } from '@hefe/models';
import {
  BasketballSwitchRequestsSlice,
  ModalsSlice,
  TasksApi,
} from '@hefe/store';
import { Col, Row, Spin, Typography } from 'antd';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../store/store';
import CustomForm from '../../core/components/form/custom-form';

interface SwitchRequestsCreateTaskFormProps {
  userId: number;
}

export default function SwitchRequestsCreateTaskForm(
  props: SwitchRequestsCreateTaskFormProps
) {
  const { userId } = props;
  const dispatch = useAppDispatch();

  const { data: possibleTasks = [], isLoading } =
    TasksApi.useFetchUserTaskAssignmentsQuery({
      userId,
      select: true,
    });

  const onSubmit = (values: any) => {
    const taskData = values.task.split(':');
    const taskId = taskData[0];
    const eventId = taskData[1];
    const isGame = taskData[2] === '1';
    const setModalLoading = ModalsSlice.modalsActions.setModalLoading;
    const closeModal = ModalsSlice.modalsActions.closeModal;

    dispatch(setModalLoading(true));
    dispatch(
      BasketballSwitchRequestsSlice.createBasketballSwitchRequest({
        event_id: eventId,
        is_game: isGame,
        note: values.note,
        user_id: props.userId,
        switch_type: BasketballSwitchRequestSwitchType.TASK,
        switch_id: taskId,
      })
    )
      .unwrap()
      .then(() => dispatch(closeModal()))
      .catch(() => null)
      .finally(() => dispatch(setModalLoading(false)));
  };

  if (isLoading) {
    return <Spin />;
  }

  return (
    <Row gutter={[0, 20]}>
      <Col xs={24}>
        <Typography.Text>
          {t('questions.create_switch_request')}
        </Typography.Text>
      </Col>
      <Col xs={24}>
        <CustomForm
          formId={`switch-request-form-create-task-${userId}`}
          fields={[
            {
              label: t('tasks.singular'),
              name: 'task',
              type: 'select',
              initalValue: null,
              selectOptions: possibleTasks as SelectOption[],
              rules: [
                {
                  required: true,
                  message: t('form_errors.select_value'),
                },
              ],
            },
            {
              label: t('note'),
              name: 'note',
              type: 'text',
              rules: [],
            },
          ]}
          onSubmit={onSubmit}
        />
      </Col>
    </Row>
  );
}
